// Generated by Melange

import * as Belt__Belt_Array from "melange.belt/belt_Array.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__Link from "../html/Link.js";
import * as Buhta_landing__Route from "../../Route.js";
import * as Stdlib__Array from "melange/array.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function BlogPagination(Props) {
  let pageNum = Props.pageNum;
  let slug = Props.slug;
  let total = Props.total;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const pageNumbers = total > 7 ? Stdlib__Array.init(((total - 1 | 0) / 7 | 0) + 1 | 0, (function (idx) {
      return idx;
    })) : [];
  const pageNumbersLength = pageNumbers.length;
  const displayNumber = deviceType === "mobile" ? 3 : 15;
  const offsetNumber = deviceType === "mobile" ? 3 : 9;
  const pageNumbersToDisplay = pageNumbersLength < (displayNumber + 2 | 0) ? pageNumbers : Belt__Belt_Array.keep(pageNumbers, (function (p) {
      const rightOffset = ((offsetNumber - pageNum | 0) - 2 | 0) > 0 ? (offsetNumber - pageNum | 0) - 2 | 0 : 0;
      const leftOffset = pageNum > (pageNumbersLength - offsetNumber | 0) ? (pageNumbersLength - displayNumber | 0) - 2 | 0 : (pageNum - offsetNumber | 0) + 1 | 0;
      if (p < (pageNum + (offsetNumber + rightOffset | 0) | 0)) {
        return p > leftOffset;
      } else {
        return false;
      }
    }));
  const backButtonStyle = pageNum === 0 ? "text-gray-light-landing" : "text-primary";
  const nextButtonStyle = (pageNum + 1 | 0) === pageNumbersLength ? "text-gray-light-landing" : "text-primary";
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("hr", {
        className: "mt-10 text-divider"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_landing__Link.make, {
            route: {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: slug === "" ? ({
                  TAG: /* Blog */ 1,
                  _0: pageNum - 1 | 0
                }) : ({
                  TAG: /* BlogSection */ 3,
                  _0: slug,
                  _1: pageNum - 1 | 0
                })
            },
            className: "paragraph-large " + backButtonStyle,
            children: "Назад",
            disabled: pageNum === 0
          }),
          JsxRuntime.jsx("div", {
            children: Stdlib__Array.map((function (num) {
              const buttonStyle = num === pageNum ? "text-primary border-2 border-primary rounded" : "text-gray-landing hover:bg-gray-pale";
              const Key = "page_num_" + String(num);
              return JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Landing */ 0,
                  _0: country,
                  _1: language,
                  _2: slug === "" ? ({
                      TAG: /* Blog */ 1,
                      _0: num
                    }) : ({
                      TAG: /* BlogSection */ 3,
                      _0: slug,
                      _1: num
                    })
                },
                className: "w-10 h-10 paragraph-large flex justify-center items-center " + buttonStyle,
                children: String(num + 1 | 0)
              }, Key);
            }), pageNumbersToDisplay),
            className: "flex border rounded-sm border border-divider"
          }),
          JsxRuntime.jsx(Buhta_landing__Link.make, {
            route: {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: slug === "" ? ({
                  TAG: /* Blog */ 1,
                  _0: pageNum + 1 | 0
                }) : ({
                  TAG: /* BlogSection */ 3,
                  _0: slug,
                  _1: pageNum + 1 | 0
                })
            },
            className: "paragraph-large " + nextButtonStyle,
            children: "Вперед",
            disabled: (pageNum + 1 | 0) === pageNumbersLength
          })
        ],
        className: "mt-10 flex justify-between items-center"
      })
    ]
  });
}

const make = BlogPagination;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
